import React from 'react';
import { connect } from 'react-redux';
import ExpenseList from './ExpenseList';
import ExpenseListFilters from './ExpenseListFilters';
import ExpenseSummary from './ExpenseSummary';
import FooterPage from './Footer';
//import ChatPopUp from '../components/Chat/Chat/ChatPopUp'
//<ChatPopUp name={user.displayName} room='Expense Users' />


const ExpenseDashboardPage = ({ user }) => {

  //console.log("Dashboard: ", user.displayName)
  return (

    <div>

      <ExpenseSummary />
      <ExpenseListFilters />
      <ExpenseList />
      <FooterPage />


    </div>
  )
};

const mapStateToProps = (state) => ({
  user: state.auth
});

export default connect(mapStateToProps, undefined)(ExpenseDashboardPage);



// WEBPACK FOOTER //
// ./src/components/ExpenseDashboardPage.js